var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2026Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 514.05 53.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        isolation: isolate;\n      }\n\n      .st1 {\n        fill: #0095ac;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "logo_IL_2024_full_-_primary"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.71,9.72c-8.67,0-15.7,7.03-15.7,15.7,0,5.41,2.74,10.18,6.91,13,.11.07.22.14.33.22.85.64,1.41,1.65,1.41,2.8v.65h3.97v-.65c0-.33-.03-.65-.07-.98h.01l-2.04-11.67-.84.13,1.39,8.01c-.41-.55-.9-1.05-1.46-1.46-.18-.13-.37-.26-.56-.37-3.19-2.2-5.09-5.8-5.09-9.67,0-6.47,5.26-11.74,11.73-11.74s11.73,5.27,11.73,11.74c0,3.79-1.83,7.34-4.91,9.54-.37.21-.72.45-1.05.72-.44.36-.83.76-1.16,1.2l1.39-7.95-.85-.1-1.92,10.98c-.03.12-.04.25-.06.38l-.05.26s0,.06-.01.08l-.02.25v1.31h3.96v-1.08c.11-.92.57-1.72,1.25-2.28.19-.15.39-.29.61-.4,4.1-2.84,6.78-7.56,6.78-12.91,0-8.67-7.03-15.7-15.69-15.7h.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 83.66,
    y: 49.45,
    width: 14.09,
    height: 3.97
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "83.66 43.79 83.66 47.76 97.75 47.76 97.75 43.79 87.63 43.79 83.66 43.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.57,25.34c.7,0,1.33.36,1.69.97.78,1.33,2.11,2.24,3.6,2.53l.85.1.6-3.44c-.14.04-.29.06-.45.06-.15,0-.29-.02-.42-.05-.53-.11-.98-.44-1.27-.93-.96-1.62-2.72-2.62-4.6-2.62s-3.64,1-4.6,2.62c-.24.41-.6.7-1.03.85-.2.08-.43.12-.66.12-.06,0-.12,0-.18-.01l.59,3.38.84-.13c1.38-.35,2.6-1.23,3.34-2.48.36-.61.99-.97,1.69-.97h.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    y: 10.28,
    width: 4.76,
    height: 30.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "32.52 31.64 15.49 10.28 11.8 10.28 11.8 40.3 16.65 40.3 16.65 19.12 33.68 40.3 37.32 40.3 37.32 10.28 32.52 10.28 32.52 31.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65.14 31.64 48.11 10.28 44.42 10.28 44.42 40.3 49.27 40.3 49.27 19.12 66.3 40.3 69.94 40.3 69.94 10.28 65.14 10.28 65.14 31.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "131.27 10.28 121.66 34.69 112.09 10.28 106.69 10.28 119.17 40.43 124.19 40.43 136.63 10.28 131.27 10.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.07,12.06c-.11-.07-.22-.14-.33-.22-.85-.64-1.41-1.67-1.41-2.82V0h-3.96v9.02c0,2.35,1.12,4.6,3,6.01.18.15.36.27.56.39,3.13,2.17,5.02,5.72,5.08,9.53-.28-.17-.51-.4-.69-.69-.96-1.64-2.72-2.65-4.6-2.65s-3.64,1.01-4.61,2.64c-.36.61-.99.98-1.69.98s-1.33-.36-1.69-.97c-.96-1.64-2.73-2.65-4.61-2.65s-3.65,1.01-4.6,2.64c-.23.39-.57.69-.98.84.02-3.8,1.85-7.34,4.91-9.55.37-.21.72-.45,1.05-.72,1.48-1.23,2.43-2.98,2.66-4.9l.03-.24V0h-3.97v9.44c-.11.92-.57,1.74-1.25,2.3-.2.16-.4.29-.62.4-4.1,2.85-6.78,7.6-6.78,13,0,8.73,7.03,15.8,15.7,15.8s15.7-7.07,15.7-15.8c0-5.45-2.74-10.25-6.91-13.09h.01ZM217.29,36.95c-5.31,0-9.81-3.58-11.25-8.46,1.41-.33,2.65-1.23,3.41-2.5.36-.61.99-.98,1.69-.98s1.33.37,1.69.98c.96,1.62,2.73,2.64,4.61,2.64s3.64-1.02,4.6-2.64c.36-.61.99-.98,1.69-.98s1.33.37,1.69.98c.7,1.2,1.84,2.05,3.13,2.43-1.41,4.93-5.93,8.53-11.26,8.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.55,10.28l-13.47,30.03h5.1l2.83-6.3h16.25l2.88,6.3h5.1l-13.47-30.03h-5.23,0ZM143.82,29.63l6.35-14.29,6.35,14.29h-12.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "163.41 14.61 173.28 14.61 173.28 40.31 178.13 40.31 178.13 14.61 187.95 14.61 187.95 10.28 163.41 10.28 163.41 14.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 191.85,
    y: 10.28,
    width: 4.76,
    height: 30.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.79 31.64 241.76 10.28 238.07 10.28 238.07 40.3 242.92 40.3 242.92 19.12 259.95 40.3 263.59 40.3 263.59 10.28 258.79 10.28 258.79 31.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "286.63 10.28 281.82 10.28 281.82 40.3 302.45 40.3 302.45 35.85 286.63 35.85 286.63 10.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.15,30.97c-.33-6.25-6.02-7.91-12.02-8.74-3.95-.56-7.29-1.37-7.29-4.29s2.92-4.55,6.95-4.55c3.13.04,6.01,1.29,7.42,3.34l3.65-2.44c-2.53-4.03-6.86-5.06-11.2-5.06-5.4,0-11.62,2.4-11.58,8.62,0,6.43,5.66,7.94,11.62,8.75,4.2.56,7.68,1.67,7.68,4.93,0,3.78-3.99,4.98-7.59,4.98s-7.21-1.29-9.35-4.93l-3.6,2.4c2.74,5.06,7.16,6.82,12.91,6.82.56,0,1.11-.03,1.66-.07,2.2.07,6.34-1.49,7.46-2.29,4.1-2.9,3.15-7.34,3.28-7.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.2,10.28l-13.47,30.03h5.11l2.83-6.3h16.26l2.87,6.3h5.1l-13.47-30.03h-5.23,0ZM314.46,29.63l6.35-14.29,6.35,14.29h-12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.47,24.82c2.83-1.16,4.16-3.43,4.16-5.96,0-5.96-4.51-8.58-10.21-8.58h-13.77v30.03h13.77c5.92,0,11.15-2.02,11.15-8.58,0-2.27-1.5-5.83-5.1-6.9h0ZM345.41,14.61h9.01c3.6,0,5.45,2.23,5.45,4.33,0,2.36-1.8,3.78-5.4,3.78h-9.05v-8.11h-.01ZM354.42,35.85h-9.01v-8.84h9.05c2.74,0,6.31,1.46,6.31,4.68s-3.69,4.16-6.35,4.16h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.87,18.72c.04-6.58,6.02-9.42,11.52-9.42,5.97,0,12.46,2.53,12.46,9.91,0,7.91-5.72,9.42-11.99,9.42-2.47,0-6.49.67-6.49,4.04v2.67h18.56v5.47h-24.2v-8.18c0-7.16,6.23-9.29,12.12-9.29,2.26,0,6.4-.4,6.4-4,0-3.38-2.95-4.98-6.79-4.98-2.95,0-5.98,1.56-6.02,4.36h-5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M426.54,22.99c0-18.58,26.21-18.54,26.21,0v4.49c0,18.54-26.21,18.58-26.21,0v-4.49ZM432.13,27.48c0,11.29,15.02,11.29,15.02,0v-4.49c0-11.11-15.02-11.25-15.02,0v4.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454.49,18.72c.04-6.58,6.02-9.42,11.52-9.42,5.97,0,12.46,2.53,12.46,9.91,0,7.91-5.72,9.42-11.99,9.42-2.47,0-6.49.67-6.49,4.04v2.67h18.56v5.47h-24.2v-8.18c0-7.16,6.23-9.29,12.12-9.29,2.26,0,6.4-.4,6.4-4,0-3.38-2.95-4.98-6.79-4.98-2.94,0-5.98,1.56-6.02,4.36h-5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M486.71,19.25v4.67c1.32-2.13,4.57-3.29,6.91-3.29,6.02,0,12.33,2.62,12.33,10.36,0,6.89-6.36,10.31-12.38,10.31s-12.46-3.42-12.46-10.4v-11.6c0-6.93,6.15-10.18,12.29-10.18,6.49,0,12.25,2.67,12.25,9.2h-5.63c0-2.76-3.33-4.13-6.53-4.13-3.37-.04-6.79,1.87-6.79,5.25v-.18ZM500.36,30.99c0-3.42-2.99-5.24-6.74-5.24s-6.96,1.78-6.91,5.24c.04,3.42,3.2,5.07,6.87,5.07s6.79-1.65,6.79-5.07Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2026Logo);
export default __webpack_public_path__ + "static/media/2026-logo.19ba6f6e0713fa1e4847c9e4fb71c1a5.svg";
export { ForwardRef as ReactComponent };